import request from '@/utils/request'

// 查询公司网点(公司门店)列表
export function listStation(query) {
  return request({
    url: '/system/station/list',
    method: 'get',
    params: query
  })
}
// 分页查询企业设备列表
export function paginationStation(query = {}, pagination) {
  query.pageNum = pagination.pageNum;
  query.pageSize = pagination.pageSize;
  return request({
    url: `/system/station/list`,
    method: 'post',
    params: query
  })
}
// 查询所有公司列表
export function listAllStation(query) {
  return request({
    url: '/system/station/listAll',
    method: 'get',
    params: query
  })
}

// 查询公司网点(公司门店)详细
export function getStation(id) {
  return request({
    url: '/system/station/' + id,
    method: 'get'
  })
}

// 新增公司网点(公司门店)
export function addStation(data) {
  return request({
    url: '/system/station',
    method: 'post',
    data: data
  })
}

// 修改公司网点(公司门店)
export function updateStation(data) {
  return request({
    url: '/system/station',
    method: 'put',
    data: data
  })
}

// 删除公司网点(公司门店)
export function delStation(id) {
  return request({
    url: '/system/station/remove/' + id,
    method: 'delete'
  })
}

// 删除公司网点(公司门店)
export function batchDelStation(id) {
  return request({
    url: '/system/station/' + id,
    method: 'delete'
  })
}
